// web-v2/src/components/sheets/PdfPreviewFrame.jsx
//
// One preview surface for a rendered PDF blob inside a review sheet
// (BrRequestDialog, CaRequestDialog). Fills whatever height its parent
// gives it, so the parent MUST have a set height: a flex-1 child of a
// max-h-only container collapses to its content and the viewer becomes a
// letterboxed sliver (David, 2026-09-30, the 7A3 Hangar 1 request).
//
// Below md the iframe is the wrong surface, not a small one: iOS Safari
// renders the first page with no scroll, Android Chrome downloads instead.
// The phone gets the one door that works, the blob in its own tab.
//
// No em dashes anywhere (CLAUDE.md hard rule).

import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button.jsx';
import useMediaQuery from '@/hooks/useMediaQuery.js';

export default function PdfPreviewFrame({ url, title, openLabel = 'Open PDF' }) {
  const isDesktop = useMediaQuery('(min-width: 768px)');
  if (!url) return null;
  if (isDesktop) {
    return (
      <iframe
        src={url}
        title={title}
        className="h-full w-full border-0 bg-white"
      />
    );
  }
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-6 py-8 text-center">
      <p className="max-w-xs text-sm text-text-muted">
        Phones do not show PDFs inline. Open it in its own tab to read the whole document.
      </p>
      <Button asChild variant="outline" className="gap-2">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <ExternalLink size={14} strokeWidth={1.75} />
          {openLabel}
        </a>
      </Button>
    </div>
  );
}
